import(/* webpackMode: "eager" */ "/home/ubuntu/stock-backend/apps/front/app/not-found.tsx");
